export const ptBR = {
  lang: 'pt-BR',
  country: 'BR',
  flag: '🇧🇷',
  currency: 'R$',

  app: {
    sidebar: {
      dashboard: 'Dashboard',
      transactions: 'Transações',
      pots: 'Potes',
      receipts: 'Recibos',
      reports: 'Relatórios',
      categories: 'Categorias',
      tags: 'Tags',
      budgets: 'Orçamento',
      recurring: 'Recorrentes',
      settings: 'Configurações',
      darkMode: 'Modo Escuro',
      lightMode: 'Modo Claro',
      logout: 'Sair',
    },
    common: {
      loading: 'Carregando...',
      save: 'Salvar',
      cancel: 'Cancelar',
      confirmTitle: 'Confirmar',
      delete: 'Excluir',
      edit: 'Editar',
      create: 'Criar',
      search: 'Buscar',
      filter: 'Filtros',
      export: 'Exportar',
      type: 'Tipo',
      category: 'Categoria',
      date: 'Data',
      amount: 'Valor',
      description: 'Descrição',
      actions: 'Ações',
      income: 'Receita',
      expense: 'Despesa',
      name: 'Nome',
      color: 'Cor',
      confirmDelete: 'Tem certeza que deseja excluir?',
      noResults: 'Nenhum resultado encontrado',
      status: 'Status',
      error: 'Erro',
      success: 'Sucesso',
      page: 'Página',
      of: 'de',
      showing: 'Mostrando',
      viewDetails: 'Ver detalhes',
      tags: 'Tags',
      receipt: 'Recibo',
      receiptAttached: 'Recibo anexado',
    },
    categoryLabels: {
      food: 'Alimentação',
      transport: 'Transporte',
      shopping: 'Compras',
      entertainment: 'Entretenimento',
      health: 'Saúde',
      education: 'Educação',
      utilities: 'Contas',
      housing: 'Moradia',
      travel: 'Viagem',
      other: 'Outros',
      salary: 'Salário',
      investment: 'Investimento',
      freelance: 'Freelance',
      gift: 'Presente',
    },
    tags: {
      loading: 'Carregando tags...',
      error: 'Não foi possível carregar suas tags. Tente novamente.',
      title: 'Tags',
      subtitle: 'Crie tags para organizar e filtrar suas transações',
      newTag: 'Nova Tag',
      noTags: 'Nenhuma tag criada',
      noTagsDescription: 'Tags são criadas automaticamente quando você usa #tag nas suas mensagens, ou você pode criar manualmente aqui.',
      createFirst: 'Criar primeira tag',
      howToUse: 'Como usar tags',
      howToUseDescription: 'Adicione tags nas suas transações via WhatsApp usando #tag. Por exemplo: "Almoco 35 reais #trabalho #almoço". As tags ajudam a filtrar e analisar seus gastos.',
      form: {
        name: 'Nome da tag',
        namePlaceholder: 'trabalho, viagem, almoço...',
        nameHint: 'Será convertido para minúsculas sem espaços',
        color: 'Cor',
      },
      stats: {
        title: 'Estatísticas',
        created: 'Tags criadas',
        totalUsage: 'Total de usos',
        mostUsed: 'Mais usada',
        unused: 'Sem uso',
      },
      confirmDelete: 'Excluir Tag',
      deleteWarning: 'Tem certeza que deseja excluir a tag',
      deleteUsageWarning: 'Esta tag está sendo usada em {count} transações. A tag será removida dessas transações.',
    },
    pots: {
      title: 'Potes',
      subtitle: 'Organize seu dinheiro em diferentes potes por moeda',
      loading: 'Carregando potes...',
      error: 'Não foi possível carregar seus potes. Tente novamente.',
      errorTitle: 'Erro ao carregar potes',
      newPot: 'Novo Pote',
      editPot: 'Editar Pote',
      noPots: 'Nenhum pote criado',
      noPotsDescription: 'Crie potes para organizar seu dinheiro por moeda ou objetivo.',
      createFirst: 'Criar primeiro pote',
      setDefault: 'Definir como padrão',
      transactions: 'transações',
      confirmDelete: 'Excluir Pote',
      confirmDeleteMessage: 'Tem certeza que deseja excluir o pote',
      deleteWarning: 'Este pote possui {count} transações que serão movidas para o pote padrão.',
      form: {
        name: 'Nome',
        namePlaceholder: 'Ex: Reserva de emergência',
        description: 'Descrição (opcional)',
        descriptionPlaceholder: 'Para que serve este pote?',
        currency: 'Moeda',
        color: 'Cor',
      },
    },
    transactions: {
      loading: 'Carregando transações...',
      title: 'Transações',
      subtitle: 'Gerencie suas receitas e despesas',
      searchPlaceholder: 'Buscar por descrição, comerciante...',
      showing: 'Mostrando {count} de {total} transações',
      confirmDelete: 'Tem certeza que deseja excluir esta transação?',
      filters: {
        filters: 'Filtros',
        dateStart: 'Data Início',
        dateEnd: 'Data Fim',
        startDate: 'Data Início',
        endDate: 'Data Fim',
        minAmount: 'Valor Mínimo',
        maxAmount: 'Valor Máximo',
      },
      table: {
        description: 'Descrição',
        category: 'Categoria',
        date: 'Data',
        amount: 'Valor',
        receipt: 'Recibo',
        actions: 'Ações',
      },
      viewReceipt: 'Ver recibo',
      modal: {
        editTitle: 'Editar Transação',
        detailsTitle: 'Detalhes da Transação',
        merchant: 'Comerciante',
        description: 'Descrição',
        tags: 'Tags',
        receipt: 'Recibo',
        receiptAttached: 'Recibo anexado',
        createCategory: 'Criar nova categoria',
      },
    },
    dashboard: {
      title: 'Dashboard',
      subtitle: 'Visão geral das suas finanças',
      period: {
        week: 'Semana',
        month: 'Mês',
        year: 'Ano',
      },
      cards: {
        income: 'Receitas',
        expense: 'Despesas',
        expenses: 'Despesas',
        balance: 'Saldo',
        transactions: 'Transações',
      },
      charts: {
        spending: 'Gastos por Categoria',
        trend: 'Tendência',
        byCategory: 'Gastos por Categoria',
      },
      recent: 'Transações Recentes',
      viewAll: 'Ver todas',
      topCategories: 'Top Categorias',
      items: 'itens',
      loading: 'Carregando dashboard...',
    },
    settings: {
      title: 'Configurações',
      subtitle: 'Gerencie seu perfil e preferências',
      profile: {
        title: 'Perfil',
        phone: 'Telefone',
        phoneVerified: 'Verificado',
        phoneHint: 'O telefone é usado para autenticação e não pode ser alterado aqui.',
        name: 'Nome',
        namePlaceholder: 'Seu nome',
        email: 'Email',
        emailPlaceholder: 'seu@email.com',
        emailHint: 'Usado para receber relatórios e notificações.',
        verified: 'Verificado',
      },
      preferences: {
        title: 'Preferências',
        language: 'Idioma',
        languageHint: 'Idioma usado nas mensagens do WhatsApp e relatórios.',
        timezone: 'Fuso Horário',
      },
      subscription: {
        title: 'Assinatura',
        plan: 'Plano',
        status: {
          active: 'Ativo',
          trialing: 'Trial',
          pastDue: 'Pagamento Pendente',
          past_due: 'Pagamento Pendente',
          canceled: 'Cancelado',
          expired: 'Expirado',
        },
        trialEnds: 'Trial termina em',
        trialEndsAt: 'Trial termina em',
        nextBilling: 'Próxima cobrança',
        upgrade: 'Fazer Upgrade',
        support: 'Falar com Suporte',
        contactSupport: 'Falar com Suporte',
        cancel: 'Cancelar assinatura',
        noSubscription: 'Sem assinatura ativa',
        noSubscriptionDesc: 'Assine um plano para desbloquear todas as funcionalidades.',
        viewPlans: 'Ver Planos',
        plans: {
          free: 'Gratuito',
          basic: 'Basic',
          starter: 'Starter',
          pro: 'Pro',
          professional: 'Profissional',
          enterprise: 'Enterprise',
          vip: 'VIP',
        },
      },
      account: {
        title: 'Informações da Conta',
        id: 'ID da conta',
        createdAt: 'Conta criada em',
      },
      saveChanges: 'Salvar Alterações',
      loading: 'Carregando configurações...',
      error: 'Erro ao carregar configurações',
      errorDesc: 'Não foi possível carregar suas informações. Tente novamente.',
    },
    budgets: {
      title: 'Orçamento',
      subtitle: 'Defina limites de gastos por categoria',
      loading: 'Carregando orçamentos...',
      error: 'Erro ao carregar orçamentos',
      errorDesc: 'Não foi possível carregar seus orçamentos. Tente novamente.',
      newBudget: 'Novo Orçamento',
      noBudgets: 'Nenhum orçamento definido',
      noBudgetsDesc: 'Crie orçamentos para controlar seus gastos por categoria e receber alertas quando estiver próximo do limite.',
      createFirst: 'Criar primeiro orçamento',
      period: {
        monthly: 'Mensal',
        yearly: 'Anual',
      },
      status: {
        safe: 'Dentro do orçamento',
        warning: 'Próximo do limite',
        danger: 'Limite excedido!',
      },
      spent: 'gasto',
      limit: 'Limite',
      remaining: 'Restam',
      exceeded: 'Excedeu',
      summary: {
        totalBudgeted: 'Total Orçado',
        totalSpent: 'Total Gasto',
        overBudget: 'Acima do Limite',
        budget: 'orçamento',
        budgets: 'orçamentos',
      },
      tips: {
        title: 'Dicas para um bom orçamento',
        tip1: 'Comece com categorias onde você gasta mais',
        tip2: 'Defina limites realistas baseados no seu histórico',
        tip3: 'Use o alerta de 80% para agir antes de exceder o limite',
        tip4: 'Revise seus orçamentos mensalmente e ajuste conforme necessário',
      },
      confirmDelete: 'Excluir Orçamento',
      confirmDeleteMsg: 'Tem certeza que deseja excluir o orçamento',
      form: {
        newBudget: 'Novo Orçamento',
        editBudget: 'Editar Orçamento',
        budgetName: 'Nome do orçamento',
        budgetNamePlaceholder: 'Ex: Alimentação mensal, Transporte...',
        category: 'Categoria (opcional)',
        allExpenses: 'Todas as despesas',
        limit: 'Limite',
        period: 'Período',
        alertThreshold: 'Alertar quando atingir',
        alertDescription: 'Você será notificado quando seus gastos atingirem este percentual do limite.',
        preview: 'Prévia',
        save: 'Salvar',
        create: 'Criar',
      },
    },
    categories: {
      title: 'Categorias',
      subtitle: 'Gerencie suas categorias de receitas e despesas',
      loading: 'Carregando categorias...',
      error: 'Erro ao carregar categorias',
      errorDesc: 'Não foi possível carregar suas categorias. Tente novamente.',
      newCategory: 'Nova Categoria',
      myCategories: 'Minhas Categorias',
      systemCategories: 'Categorias do Sistema',
      systemCategoriesDesc: 'Estas categorias são padrão do sistema e não podem ser editadas.',
      noCustomCategories: 'Nenhuma categoria personalizada',
      noCustomCategoriesDesc: 'Crie categorias personalizadas para organizar melhor suas finanças.',
      createFirst: 'Criar primeira categoria',
      type: {
        income: 'Receita',
        expense: 'Despesa',
      },
      deductible: 'Dedutível',
      confirmDelete: 'Excluir Categoria',
      confirmDeleteMsg: 'Tem certeza que deseja excluir a categoria',
      deleteWarning: 'Transações existentes com esta categoria serão movidas para "Outros".',
      form: {
        newCategory: 'Nova Categoria',
        editCategory: 'Editar Categoria',
        categoryName: 'Nome da categoria',
        categoryNamePlaceholder: 'Ex: Alimentação, Transporte...',
        type: 'Tipo',
        icon: 'Ícone',
        colour: 'Cor',
        preview: 'Prévia',
        taxDeductible: 'Dedutível no imposto de renda',
        save: 'Salvar',
        create: 'Criar',
      },
    },
    receipts: {
      title: 'Recibos',
      subtitle: 'Visualize e gerencie seus comprovantes fiscais',
      loading: 'Carregando recibos...',
      error: 'Erro ao carregar recibos',
      errorDesc: 'Não foi possível carregar seus recibos. Tente novamente.',
      status: {
        all: 'Todos os Status',
        processing: 'Processando',
        completed: 'Concluídos',
        failed: 'Falhou',
        manual_review: 'Revisão Manual',
      },
      year: {
        all: 'Todos os Anos',
      },
      stats: {
        total: 'Total',
        completed: 'Concluídos',
        processing: 'Processando',
        failed: 'Falhou',
      },
      noReceipts: 'Nenhum recibo ainda',
      noReceiptsFiltered: 'Nenhum recibo encontrado',
      noReceiptsDesc: 'Envie uma foto de recibo via WhatsApp para começar a organizar seus gastos',
      noReceiptsFilteredDesc: 'Tente ajustar os filtros para ver mais recibos',
      showing: 'Mostrando {count} de {total} recibos',
      page: 'Página {current} de {total}',
    },
    recurring: {
      title: 'Transações Recorrentes',
      subtitle: 'Automatize suas despesas e receitas fixas',
      loading: 'Carregando transações recorrentes...',
      error: 'Erro ao carregar transações recorrentes',
      errorDesc: 'Não foi possível carregar suas transações recorrentes. Tente novamente.',
      newRecurring: 'Nova Recorrente',
      noRecurring: 'Nenhuma transação recorrente',
      noRecurringDesc: 'Configure transações que se repetem automaticamente, como aluguel, assinaturas ou salário.',
      createFirst: 'Criar primeira recorrente',
      active: 'Ativa',
      paused: 'Pausada',
      activeCount: 'Ativas ({count})',
      pausedCount: 'Pausadas ({count})',
      next: 'Próxima',
      summary: {
        monthlyExpenses: 'Despesas Mensais',
        monthlyIncome: 'Receitas Mensais',
        netMonthly: 'Saldo Mensal',
      },
      frequency: {
        daily: 'Diária',
        weekly: 'Semanal',
        monthly: 'Mensal',
        yearly: 'Anual',
      },
      dayOf: {
        everyDay: 'Todo dia',
        every: 'Toda',
        dayOfMonth: 'Todo dia {day}',
        annually: 'Anualmente',
      },
      actions: {
        pause: 'Pausar',
        activate: 'Ativar',
        processNow: 'Processar agora',
      },
      tips: {
        title: 'Sobre Transações Recorrentes',
        tip1: 'Transações são criadas automaticamente na data programada',
        tip2: 'Você pode pausar temporariamente sem excluir',
        tip3: 'Use para despesas fixas como aluguel, luz, internet',
        tip4: 'Também funciona para receitas como salário ou aluguéis recebidos',
      },
      confirmDelete: 'Excluir Transação Recorrente',
      confirmDeleteMsg: 'Tem certeza que deseja excluir a transação recorrente',
      deleteWarning: 'Transações já criadas não serão afetadas.',
      form: {
        newRecurring: 'Nova Transação Recorrente',
        editRecurring: 'Editar Transação Recorrente',
        description: 'Descrição',
        descriptionPlaceholder: 'Ex: Aluguel, Netflix, Salário...',
        amount: 'Valor',
        category: 'Categoria',
        selectCategory: 'Selecione uma categoria',
        selectPot: 'Selecione um pote (opcional)',
        frequencyLabel: 'Frequência',
        dayOfMonth: 'Dia do mês',
        dayOfWeek: 'Dia da semana',
        day: 'Dia',
        startDate: 'Data de início',
        endDate: 'Data de fim (opcional)',
        preview: 'Prévia',
        save: 'Salvar',
        create: 'Criar',
        daysOfWeek: {
          monday: 'Segunda-feira',
          tuesday: 'Terça-feira',
          wednesday: 'Quarta-feira',
          thursday: 'Quinta-feira',
          friday: 'Sexta-feira',
          saturday: 'Sábado',
          sunday: 'Domingo',
        },
      },
    },
    reports: {
      title: 'Relatórios Fiscais',
      subtitle: 'Resumos anuais para declaração de impostos',
      loading: 'Carregando relatórios...',
      error: 'Erro ao carregar relatórios',
      errorDesc: 'Não foi possível carregar seus relatórios. Tente novamente.',
      year: {
        all: 'Todos os anos',
      },
      noReports: 'Nenhum relatório ainda',
      noReportsFiltered: 'Nenhum relatório encontrado',
      noReportsDesc: 'Seus relatórios fiscais aparecerão aqui quando forem gerados automaticamente ao final de cada ano.',
      noReportsFilteredDesc: 'Não há relatórios para o ano de {year}.',
      generatedOn: 'Gerado em',
      card: {
        income: 'Receitas',
        expenses: 'Despesas',
        deductible: 'Dedutíveis',
        balance: 'Saldo',
      },
      country: {
        BR: 'Brasil',
        GB: 'Reino Unido',
      },
      tips: {
        title: 'Sobre os Relatórios Fiscais',
        desc: 'Os relatórios são gerados automaticamente ao final de cada ano fiscal. Eles incluem um resumo de todas as suas receitas, despesas e gastos dedutíveis, organizados por categoria.',
        tip1: 'Brasil: Ano fiscal de Janeiro a Dezembro',
        tip2: 'UK: Ano fiscal de Abril a Março',
      },
    },
  },

  nav: {
    pricing: 'Preços',
    features: 'Funcionalidades',
    howItWorks: 'Como Funciona',
    login: 'Entrar',
  },

  hero: {
    badge: 'Controle financeiro sem fricção',
    title: 'Organize suas finanças pelo WhatsApp',
    subtitle: 'Manda uma mensagem, foto ou áudio. A IA registra, categoriza e organiza tudo pra você.',
    cta: 'Começar Grátis',
    ctaSubtext: '14 dias grátis, sem cartão',
    ukOnly: 'Disponível apenas para números do Reino Unido no momento',
    trustedBy: 'Simples como mandar uma mensagem',
  },

  howItWorks: {
    title: 'Como Funciona',
    subtitle: 'Três formas de registrar. Zero esforço.',
    step1: {
      icon: '💬',
      title: 'Texto',
      description: 'Digite naturalmente: "50 almoço", "+500 salário", "uber ontem era trabalho"',
      example: '"85 mercado"',
    },
    step2: {
      icon: '📸',
      title: 'Foto',
      description: 'Manda foto do recibo. OCR extrai valor, loja, CNPJ e itens automaticamente.',
      example: 'Foto do cupom fiscal',
    },
    step3: {
      icon: '🎤',
      title: 'Áudio',
      description: 'Grava um áudio descrevendo o gasto. Transcrevemos e registramos.',
      example: '"Gastei 200 no posto"',
    },
  },

  features: {
    title: 'Muito mais que um registro de gastos',
    subtitle: 'Ferramentas poderosas, interface simples',
    list: [
      {
        icon: 'wallet',
        title: 'Pots (Carteiras)',
        description: 'Organize por conta: Nubank, Itaú, Projeto X. Cada pot com sua moeda.',
        command: '"criar pot Nubank"',
      },
      {
        icon: 'target',
        title: 'Orçamentos',
        description: 'Defina limites por categoria. Alerta quando atingir 80%.',
        command: '"orçamento 500 alimentação"',
      },
      {
        icon: 'hash',
        title: 'Tags',
        description: 'Use #hashtags pra organizar: "50 uber #cliente #projeto-x"',
        command: '"meus gastos #trabalho"',
      },
      {
        icon: 'repeat',
        title: 'Recorrentes',
        description: 'Configure gastos fixos. Aluguel, Netflix, salário - registrado automático.',
        command: '"criar recorrente 1500 aluguel"',
      },
      {
        icon: 'globe',
        title: 'Multi-moeda',
        description: 'R$, £, $, €. Taxas atualizadas do BCB. Dashboard consolidado.',
        command: '"50 usd almoço pot Viagem"',
      },
      {
        icon: 'layout',
        title: 'Dashboard Web',
        description: 'Gráficos, filtros, exportação. Tudo que você registra, visível no portal.',
        command: 'keepnota.com',
      },
    ],
  },

  commands: {
    title: 'Comandos Rápidos',
    subtitle: 'Conversa natural. Sem decorar nada.',
    list: [
      { cmd: '50 café', desc: 'Registra gasto de R$50' },
      { cmd: '+2000 freelance', desc: 'Registra receita' },
      { cmd: 'resumo', desc: 'Mostra resumo do mês' },
      { cmd: 'meus pots', desc: 'Lista suas carteiras' },
      { cmd: 'apagar último', desc: 'Remove última transação' },
      { cmd: 'ajuda', desc: 'Lista todos comandos' },
    ],
  },

  audience: {
    title: 'Feito pra quem quer simplicidade',
    subtitle: 'Se você usa WhatsApp, já sabe usar o KeepNota',
    personas: [
      {
        icon: 'briefcase',
        title: 'Autônomos e MEIs',
        description: 'Separe pessoal de trabalho. Saiba exatamente quanto entra e sai.',
      },
      {
        icon: 'user',
        title: 'Finanças Pessoais',
        description: 'Chega de planilha. Registre gastos no momento que acontecem.',
      },
      {
        icon: 'users',
        title: 'Casais e Famílias',
        description: 'Pots compartilhados. Cada um registra, todos acompanham.',
      },
      {
        icon: 'plane',
        title: 'Viajantes',
        description: 'Multi-moeda automático. Gastos em qualquer lugar, tudo convertido.',
      },
    ],
  },

  comparison: {
    title: 'Por que KeepNota?',
    subtitle: 'Comparado com as alternativas',
    vsSpreadsheet: {
      title: 'vs Planilha',
      points: [
        'Sem abrir computador',
        'Registro instantâneo',
        'Categoriza sozinho',
        'Foto do recibo = tudo preenchido',
      ],
    },
    vsApps: {
      title: 'vs Apps de Finanças',
      points: [
        'Funciona no WhatsApp (já usa todo dia)',
        'Zero atrito - só manda mensagem',
        'OCR de recibos incluído',
        'Sem notificações irritantes',
      ],
    },
    vsManual: {
      title: 'vs Anotar Manual',
      points: [
        'Nunca esquece de registrar',
        'Áudio quando não pode digitar',
        'Histórico sempre acessível',
        'Relatórios automáticos',
      ],
    },
  },

  taxBonus: {
    title: 'Bônus: Pronto pro Imposto de Renda',
    subtitle: 'Quando chegar a época, seus dados já estão organizados',
    points: [
      'Categorias mapeadas para deduções do IR',
      'CNPJ capturado automaticamente dos recibos',
      'Relatório anual exportável',
      'Separe despesas dedutíveis com tags',
    ],
  },

  pricing: {
    title: 'Planos',
    subtitle: 'Comece grátis. Upgrade quando precisar.',
    monthly: '/mês',
    yearly: '/ano',
    savePercent: 'Economize 20%',
    basic: {
      name: 'Basic',
      price: '19,90',
      features: [
        '30 fotos de recibo/mês',
        '20 áudios/mês',
        'Textos ilimitados',
        'Dashboard e gráficos básicos',
        'Relatório mensal',
        'Exportar CSV',
        'Retenção de recibos: 1 ano',
      ],
    },
    pro: {
      name: 'Pro',
      price: '39,90',
      popular: 'Mais Popular',
      features: [
        'Fotos e áudios ilimitados',
        'Tudo do Basic +',
        'Gráficos e filtros avançados',
        'Comparativo mês a mês',
        'Exportar PDF',
        'Relatório anual (IR)',
        'Suporte prioritário',
        'Retenção de recibos: 2 anos',
      ],
    },
    cta: 'Começar Grátis',
    trial: '14 dias grátis, cancele quando quiser',
  },

  referral: {
    title: 'Indique e Ganhe',
    subtitle: 'Compartilhe com amigos e ganhe dias grátis',
    tiers: [
      { range: '1-5 indicações', reward: '7 dias grátis cada' },
      { range: '6-15 indicações', reward: '10 dias grátis cada' },
      { range: '16+ indicações', reward: '14 dias + créditos' },
    ],
    cta: 'Saiba mais',
  },

  faq: {
    title: 'Dúvidas Frequentes',
    items: [
      {
        q: 'Preciso baixar algum app?',
        a: 'Não! Funciona 100% pelo WhatsApp. Basta salvar nosso número e começar a mandar seus gastos. Também temos um portal web pra ver gráficos e relatórios.',
      },
      {
        q: 'Meus dados estão seguros?',
        a: 'Sim! Usamos criptografia de ponta a ponta, servidores seguros e seguimos a LGPD. Você pode exportar ou deletar seus dados a qualquer momento.',
      },
      {
        q: 'Posso cancelar quando quiser?',
        a: 'Claro! Sem fidelidade. Cancele a qualquer momento pelo próprio WhatsApp digitando "cancelar". Seus dados ficam disponíveis por 30 dias após o cancelamento.',
      },
      {
        q: 'Funciona pra MEI e autônomos?',
        a: 'Perfeito pra isso! Use pots pra separar conta pessoal de PJ, tags pra clientes, e tenha controle total de receitas e despesas.',
      },
      {
        q: 'Como funciona o OCR de recibos?',
        a: 'Manda a foto do cupom fiscal ou nota. Nossa IA extrai automaticamente: valor total, nome da loja, CNPJ, data e até os itens. Só conferir e pronto.',
      },
      {
        q: 'Posso usar em mais de uma moeda?',
        a: 'Sim! Suportamos Real, Dólar, Euro e Libra. Cada pot pode ter sua moeda, e o dashboard mostra tudo convertido na sua moeda principal.',
      },
    ],
  },

  cta: {
    title: 'Comece a organizar suas finanças hoje',
    subtitle: '14 dias grátis. Sem cartão. Cancele quando quiser.',
    button: 'Falar no WhatsApp',
    secondary: 'Ver demonstração',
  },

  footer: {
    copyright: '© 2025 KeepNota by Fig and Rosa Ltd. All rights reserved.',
    terms: 'Termos de Uso',
    privacy: 'Privacidade',
    tagline: 'Controle financeiro via WhatsApp',
  },

  privacy: {
    title: 'Política de Privacidade',
    lastUpdate: 'Última atualização: Dezembro de 2024',
    intro: 'A KeepNota ("nós", "nosso" ou "Serviço") valoriza a privacidade dos usuários. Esta Política de Privacidade explica como coletamos, usamos e protegemos suas informações.',
    sections: [
      {
        title: '1. Dados que Coletamos',
        content: `Coletamos os seguintes dados quando você usa o KeepNota:
• **Número de telefone**: Para identificação e comunicação via WhatsApp
• **Mensagens enviadas**: Textos, áudios e imagens de notas fiscais que você envia
• **Dados extraídos**: Valores, categorias e informações das notas fiscais processadas
• **Dados de uso**: Horários de acesso e interações com o serviço`,
      },
      {
        title: '2. Como Usamos seus Dados',
        content: `Utilizamos seus dados para:
• Processar e organizar suas notas fiscais
• Gerar relatórios e gráficos de gastos
• Identificar despesas dedutíveis no Imposto de Renda
• Melhorar nossos serviços e algoritmos de IA
• Enviar comunicações sobre sua conta e o serviço`,
      },
      {
        title: '3. Armazenamento e Segurança',
        content: `Seus dados são armazenados com segurança:
• Criptografia em trânsito (HTTPS/TLS)
• Armazenamento em servidores seguros
• Acesso restrito apenas a sistemas automatizados
• Backups regulares e redundância de dados`,
      },
      {
        title: '4. Compartilhamento de Dados',
        content: `**Não vendemos seus dados.** Compartilhamos apenas com:
• **Provedores de serviço**: Processamento de pagamentos (Stripe), armazenamento (AWS)
• **IA/ML**: Google (Gemini) para processamento de imagens e texto - dados anonimizados
• **Obrigação legal**: Quando exigido por lei ou ordem judicial`,
      },
      {
        title: '5. Seus Direitos (LGPD)',
        content: `Você tem direito a:
• **Acesso**: Solicitar cópia dos seus dados
• **Correção**: Corrigir dados incorretos
• **Exclusão**: Solicitar exclusão dos seus dados
• **Portabilidade**: Receber seus dados em formato estruturado
• **Revogação**: Cancelar o consentimento a qualquer momento

Para exercer seus direitos, envie mensagem para nosso WhatsApp ou email: privacidade@keepnota.com`,
      },
      {
        title: '6. Retenção de Dados',
        content: `Mantemos seus dados enquanto sua conta estiver ativa. Após cancelamento:
• Dados financeiros: Mantidos por 5 anos (obrigação fiscal)
• Imagens de notas: Excluídas em 30 dias
• Dados de conta: Excluídos em 30 dias`,
      },
      {
        title: '7. Contato',
        content: `Para dúvidas sobre privacidade:
• Email: privacidade@keepnota.com
• WhatsApp: Envie "PRIVACIDADE" para nosso número`,
      },
    ],
  },

  feedback: {
    title: 'Envie seu Feedback',
    subtitle: 'Sua opinião nos ajuda a melhorar o KeepNota',
    typeLabel: 'Tipo de feedback',
    types: {
      general: 'Geral',
      feature_request: 'Sugestão',
      bug: 'Bug/Erro',
      complaint: 'Reclamação',
      praise: 'Elogio',
      account_deletion: 'Excluir conta',
    },
    messageLabel: 'Sua mensagem',
    messagePlaceholder: 'Conte-nos o que você pensa...',
    ratingLabel: 'Avaliação (opcional)',
    nameLabel: 'Seu nome (opcional)',
    namePlaceholder: 'Como podemos te chamar?',
    emailLabel: 'Email (opcional)',
    emailPlaceholder: 'seu@email.com',
    emailHint: 'Para respondermos seu feedback',
    submit: 'Enviar Feedback',
    errors: {
      messageRequired: 'Por favor, escreva uma mensagem',
      messageTooShort: 'Mensagem muito curta (mínimo 10 caracteres)',
      submitFailed: 'Erro ao enviar. Tente novamente.',
    },
    success: {
      title: 'Feedback enviado!',
      message: 'Obrigado por compartilhar sua opinião. Vamos analisar com carinho.',
    },
    backToHome: 'Voltar para página inicial',
  },

  terms: {
    title: 'Termos de Uso',
    lastUpdate: 'Última atualização: Dezembro de 2024',
    intro: 'Ao usar o KeepNota, você concorda com estes Termos de Uso. Leia atentamente.',
    sections: [
      {
        title: '1. Sobre o Serviço',
        content: `O KeepNota é um serviço de organização de notas fiscais e despesas via WhatsApp. Oferecemos:
• Processamento automático de notas fiscais por foto, áudio ou texto
• Categorização e organização de despesas
• Relatórios e gráficos de gastos
• Identificação de despesas dedutíveis no IR

O serviço é fornecido "como está" e pode ser modificado a qualquer momento.`,
      },
      {
        title: '2. Cadastro e Conta',
        content: `Para usar o KeepNota:
• Você deve ter 18 anos ou mais
• Fornecer informações verdadeiras
• Manter seu número de telefone atualizado
• Não compartilhar acesso com terceiros

Você é responsável por todas as atividades em sua conta.`,
      },
      {
        title: '3. Uso Aceitável',
        content: `Você concorda em NÃO:
• Usar o serviço para fins ilegais
• Enviar conteúdo ofensivo, difamatório ou ilegal
• Tentar acessar sistemas ou dados de outros usuários
• Usar bots ou automação não autorizada
• Revender ou redistribuir o serviço`,
      },
      {
        title: '4. Pagamentos e Assinatura',
        content: `• Oferecemos período de teste gratuito de 14 dias
• Após o teste, a assinatura é cobrada mensalmente
• Pagamentos processados via Stripe (cartão de crédito)
• Cancelamento pode ser feito a qualquer momento
• Não há reembolso por períodos parciais`,
      },
      {
        title: '5. Propriedade Intelectual',
        content: `• O KeepNota e seus componentes são propriedade da Figrosa
• Você mantém propriedade dos seus dados e notas fiscais
• Nós concedemos licença limitada para usar o serviço
• Você nos concede licença para processar seus dados conforme necessário`,
      },
      {
        title: '6. Limitação de Responsabilidade',
        content: `• O KeepNota não substitui aconselhamento contábil ou fiscal
• Não garantimos precisão absoluta no processamento de notas
• Não somos responsáveis por decisões fiscais baseadas no serviço
• Nossa responsabilidade é limitada ao valor pago pelo serviço`,
      },
      {
        title: '7. Cancelamento',
        content: `Você pode cancelar a qualquer momento:
• Envie "CANCELAR" pelo WhatsApp
• Acesse sua conta no portal
• O acesso continua até o fim do período pago
• Seus dados serão excluídos conforme nossa Política de Privacidade`,
      },
      {
        title: '8. Alterações nos Termos',
        content: `Podemos alterar estes termos a qualquer momento. Notificaremos via:
• Mensagem no WhatsApp
• Email (se cadastrado)
• Aviso no portal

O uso continuado após alterações constitui aceitação.`,
      },
      {
        title: '9. Contato',
        content: `Para dúvidas sobre os Termos:
• Email: suporte@keepnota.com
• WhatsApp: Envie "AJUDA" para nosso número`,
      },
    ],
  },
};
